export default "/images/neighborhoods-home-icon.svg?623809c8cb4b542af96ebf56c0994508";